<template>
  <div
    class="p-2 text-1xl font-bold text-center leading-tight"
    :style="{ color, backgroundColor }"
  >
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String
    },
    backgroundColor: {
      type: String
    },
    text: {
      type: String
    }
  }
}
</script>
